import "./Info.css";

import React, { useContext } from "react";
import globalContext from "../../Contexts/GlobalContext";

export default function Info({ infoText }) {
  const contextData = useContext(globalContext);
  return (
    <div
      className="bg-color-primary-B absolute w-full font-font_primary_A h-auto p-[2vw] rounded-t-[2.8vw] z-[10000] up"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className="flex items-center justify-between mt-[2vw]">
        <button
          className="bg-[#f3f3f3] font-font_primary_A w-[50%] mx-[2.5vw] px-[12vw] py-[1vw] rounded-[0.9vw] text-[2.5vw] font-semibold text-[#153038]"
          onClick={() => {
            contextData.setIsInfoOpen(false);
          }}
        >
          متوجه شدم
        </button>
        <button
          className="bg-[#153038] font-font_primary_A ml-[2.5vw] px-[2vw] py-[1vw] rounded-[0.9vw] text-[2.5vw] text-[#FFF]"
          onClick={() => {
            localStorage.setItem("shortInfoCheck", true);
            localStorage.setItem("addCarInfoCheck", true);
            localStorage.setItem("carDetailsInfoCHeck", true);
            localStorage.setItem("pieceDetailsInfoCHeck", true);

            contextData.setIsInfoOpen(false);
          }}
        >
          کلاٌ بیخیال
        </button>
      </div>
      <p className="text-[3.5vw] text-[#153038] p-[3vw] text-justify">
        {infoText}
      </p>
    </div>
  );
}
